import { isUndefined } from 'lodash';
import axios from 'src/utils/axios';
import parse from 'src/utils/parse';


class ProjectModulesApi {
    async getAllModules(args: any): Promise<any> {
        if (args.limit !== undefined) {
            args.pageSize = args.limit; // Add pageSize property
            delete args.limit;          // Remove limit property
        }
        return new Promise((resolve, reject) => {
            axios
                .get(`${process.env.REACT_APP_CASES}/itsmModules`, { params: args })
                .then((response) => {
                    response = parse(response);
                    if (!isUndefined(response?.data)) {
                        resolve(response);
                    }
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }


    async getModulesByOrgAndProject(orgId, projectId: any): Promise<any> {
        return new Promise((resolve, reject) => {
            axios
                .get(`${process.env.REACT_APP_CASES}/itsmModules/getByOrgAndProject/${orgId}/${projectId}`)
                .then((response) => {
                    response = parse(response);
                    if (!isUndefined(response?.data)) {
                        resolve(response);
                    }
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    async createModule(args: any): Promise<any> {
        return new Promise((resolve, reject) => {
            axios.post(`${process.env.REACT_APP_CASES}/itsmModules`, args).then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    async updateModule(id: string, body: any): Promise<any> {
        return new Promise((resolve, reject) => {
            axios.patch(`${process.env.REACT_APP_CASES}/itsmModules/${id}`, body).then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    async updateStatusById(id: string, isActive: boolean): Promise<any> {
        return new Promise((resolve, reject) => {
            axios.patch(`${process.env.REACT_APP_CASES}/itsmModules/${id}/toggle?isActive=${isActive}`).then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    async bulkUpdateStatus(body: any): Promise<any> {
        return new Promise((resolve, reject) => {
            axios.patch(`${process.env.REACT_APP_CASES}/itsmModules/bulkToggle`, body).then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
        });
    }
}

export const projectModulesApi = new ProjectModulesApi();
